import { quickOrderProductListStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

quickOrderProductListStyles.productNumberText = {
    css: css`
        color: ${getColor("text.main")};
    `,
};

quickOrderProductListStyles.totalText = {
    css: css`
        float: right;
        font-weight: bold;
        margin: 15px 0;
        color: ${getColor("text.main")};
    `,
};
// quickOrderProductListStyles.removeProductGridItem = {
//     css: css`
//         text-align: center;
//         display: block;
//         ${({ theme }: { theme: BaseTheme }) =>
//             breakpointMediaQueries(
//                 theme,
//                 [
//                     css`
//                         display: flex;
//                         align-items: center;
//                         justify-content: space-between;
//                         flex-direction: row-reverse;
//                         padding: 15px 0px;
//                         flex-basis: 75%;
//                         max-width: 75%;
//                     `,
//                     null,
//                     null,
//                     null,
//                     null,
//                 ],
//                 "max",
//             )}
//     `,
//     width: [12, 3, 3, 3, 3],
// };

quickOrderProductListStyles.removeProductClickable = {
    css: css`
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 15px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-bottom: 15px;
                `,
                css`
                    margin-bottom: 15px;
                `,
                css`
                    margin-bottom: 15px;
                `,
                null,
                null,
            ])}
    `,
};

quickOrderProductListStyles.gridContainer = {
    css: css`
        > div[class^="GridOffset"] {
            //  justify-content: center;
        }
    `,
};
